import { companyListCertifiedReducer } from "../reducer/CompanyListCertidiedReducer";

export const reducer = companyListCertifiedReducer;